import { Modal } from '@flightstats/airframe-react';
import { modalContentStyle } from '../components/modal/Modal';
import React, { useEffect, useState } from 'react';
import _ from 'lodash';
import { InformationalProps } from '../headersegment/interfaces';

interface OptionOverrides {
  title?: string;
  confirmButtonText?: string;
  cancelButtonText?: string | null;
  message2?: string | null | undefined;
  onSubmit?: () => void;
  cancel?: () => void;
}

export const Confirmation: React.FC<{
  message: string;
  optionOverrides: OptionOverrides;
}> = ({ message, optionOverrides }) => {
  let option = {
    title: 'Confirm',
    message: message,
    confirmButtonText: 'Yes',
    cancelButtonText: 'No',
    message2: null,
  };
  _.assign(option, optionOverrides || {});
  const [options, setOptions] = useState(option);

  useEffect(() => {
    setOptions({ ...option, message: message });
}, [message, optionOverrides]);

  const ok = () => {
    if (optionOverrides.onSubmit) {
      optionOverrides.onSubmit();
    }
  };

  const cancel = () => {
    if (optionOverrides.cancel) {
      optionOverrides.cancel();
    }
  };

  return (
    <Modal isOpen={true} contentStyle={modalContentStyle}>
      <div className="issue-resolution-modal modal-dialog modal-md">
        <form name="form" noValidate>
          <div className="title">
            {options.title}
            <a onClick={cancel}>
              <i
                id="modalCancelled"
                className="cancel pull-right glyphicon icon-white glyphicon-remove"
              ></i>
            </a>
          </div>

          <div className="content">
            <div className="choices">
              <div className="row">
                <div className="col-md-12 center">{options.message}</div>
              </div>

              {options.message2 && (
                <div className="row">
                  <div className="col-md-12 center fs-exclude" data-fs-exclude>{options.message2}</div>
                </div>
              )}
            </div>

            <div className="action">
              <button type='button'
                id="modalSubmitted"
                className="btn btn-default modal-btn-margin-right"
                onClick={ok}
              >
                {options.confirmButtonText}
              </button>

              {options.cancelButtonText && (
                <button type='button'
                  id="modalCancelSubmitted"
                  className="btn btn-default modal-btn-margin-right"
                  onClick={cancel}
                >
                  {options.cancelButtonText}
                </button>
              )}
            </div>
          </div>
        </form>
      </div>
    </Modal>
  );
};

export const Informational = ({
  title,
  message1,
  useCancelButton,
  message2,
  cancel,
  onSubmit,
}: InformationalProps) => (
  <Confirmation
    message={message1}
    optionOverrides={{
      title: title,
      confirmButtonText: 'OK',
      cancelButtonText: useCancelButton ? 'CANCEL' : null,
      message2: message2 || null,
      cancel: cancel,
      onSubmit: onSubmit,
    }}
  />
);

export const feedback = () => {
  const mailtoLink = 'mailto:helpdesk@cirium.com';
  window.location.href = mailtoLink;
};
